import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import * as moment from 'moment'
import { APIServiceProvider } from '../../common/services/api.service';
import { HelperServiceProvider } from '../../common/services/helper.service';
import { NotifyService } from '../../services/notify.service';


/**
 * Generated class for the OrderCancelPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-order-cancel',
  templateUrl: 'order-cancel.html',
})
export class OrderCancelPage {
  public order : any = {};
  public statusData = [{
      id: -1,
      value: "Cancelled"
  }];
  public orderData = {
      order_status: -1,
      cancel_reason_id: null,
      cancel_reason_text: null,
  };

  public cancel_list: any = [];
  public submitDisabled = false;

  constructor(
    public modalCtrl: ModalController,
    private apiService: APIServiceProvider,
    private notifyService: NotifyService,
    private helperService: HelperServiceProvider,
    public viewCtrl:ViewController,
    public navParam:NavParams
  ) { }

  ngOnInit() {
   console.log(this.navParam.data)
    this.order["received_date"] = moment(this.navParam.data['order']["received_date"]).format("DD-MMM-YYYY HH:mm:s").toString();
    this.orderData["order_id"] = this.navParam.data['order']["order_id"];
    console.log(this.orderData)
    this.getCancelList();
  }
  dismiss() {
		this.viewCtrl.dismiss();
	}
  
  getCancelList() {
    this.apiService.get("order/get-reason-list")
    .subscribe(response => {
      this.cancel_list = response['data'];
    });
  }

  sendCancel() {
    if (!this.orderData.cancel_reason_id) {
        this.helperService.presentToast("Please select cancellation reason");
        return false;
    }

    if (this.orderData.cancel_reason_id == -1) {
        if (!this.orderData.cancel_reason_text) {
            this.helperService.presentToast("Please enter text for cancellation!");
            return false;
        }
    }

    this.submitDisabled = true;
    this.apiService.post("v1.2/order/save-order-status/" + this.orderData["order_id"], this.orderData)
    .subscribe(result => {
      this.notifyService.OrderModified(true);
      this.submitDisabled = false;
      this.helperService.presentToast("Success");
      this.notifyService.OrderCancelled(true);
      this.dismiss();
    },
    error => {
      this.helperService.presentToast(error['error'].msg);
      this.submitDisabled = false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/modals/order-cancel/order-cancel.ts